"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = deleteActivity;
exports.DELETE_ACTIVITY = void 0;
var DELETE_ACTIVITY = 'DIRECT_LINE/DELETE_ACTIVITY';
exports.DELETE_ACTIVITY = DELETE_ACTIVITY;

function deleteActivity(activityID) {
  return {
    type: DELETE_ACTIVITY,
    payload: {
      activityID: activityID
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL2RlbGV0ZUFjdGl2aXR5LmpzIl0sIm5hbWVzIjpbIkRFTEVURV9BQ1RJVklUWSIsImRlbGV0ZUFjdGl2aXR5IiwiYWN0aXZpdHlJRCIsInR5cGUiLCJwYXlsb2FkIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQU8sSUFBTUEsZUFBZSxHQUFHLDZCQUF4Qjs7O0FBRVEsU0FBU0MsY0FBVCxDQUF3QkMsVUFBeEIsRUFBb0M7QUFDakQsU0FBTztBQUNMQyxJQUFBQSxJQUFJLEVBQUVILGVBREQ7QUFFTEksSUFBQUEsT0FBTyxFQUFFO0FBQUVGLE1BQUFBLFVBQVUsRUFBVkE7QUFBRjtBQUZKLEdBQVA7QUFJRCIsInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBERUxFVEVfQUNUSVZJVFkgPSAnRElSRUNUX0xJTkUvREVMRVRFX0FDVElWSVRZJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gZGVsZXRlQWN0aXZpdHkoYWN0aXZpdHlJRCkge1xuICByZXR1cm4ge1xuICAgIHR5cGU6IERFTEVURV9BQ1RJVklUWSxcbiAgICBwYXlsb2FkOiB7IGFjdGl2aXR5SUQgfVxuICB9O1xufVxuIl19